/**
 * Auto-generated version file
 * Generated from git tag: v1.0.2
 * DO NOT EDIT - This file is automatically generated during build
 */

export const UI_VERSION = 'v1.0.2';
